import { modelOptions, prop, ReturnModelType, Severity } from '@typegoose/typegoose';
import mongoose from 'mongoose';
import { IntegrationType } from './integration.type.enum';

@modelOptions({
  schemaOptions: { collection: 'integrationsConfig' },
  options: { customName: 'integrationsConfig', allowMixed: Severity.ALLOW },
})
export class IntegrationsConfig {
  @prop({ required: true, _id: true })
  _id: mongoose.Types.ObjectId;

  @prop({ required: true, type: Number, enum: IntegrationType })
  integrationType: IntegrationType;

  @prop({ required: true })
  protectedEntityId: mongoose.Types.ObjectId;

  @prop({ type: mongoose.Schema.Types.Mixed })
  settings?: unknown;

  /**
   * We need to narrow down the TS type and pre-filter the collection, discriminators are not an option, because we use
   * integer types and Typegoose is built to work with string discriminators.
   *
   * NOTE: you MUST implement this method for all subtypes of IntegrationsConfig
   *
   * (see https://typegoose.github.io/typegoose/docs/guides/advanced/non-nested-discriminators)
   */
  public static getQuery(
    this: ReturnModelType<typeof IntegrationsConfig>,
    type?: IntegrationType
  ): mongoose.Query<IntegrationsConfig[], IntegrationsConfig> {
    throw new Error('Unimplemented');
  }
}
